var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptySnag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 109,
    viewBox: "0 0 118 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.4562 39.95C71.0762 39.95 62.5662 39.61 54.5962 37.39C46.7762 35.21 39.5962 31.01 33.1962 26.14C28.9962 22.96 25.1962 20.44 19.7462 20.82C14.4305 21.0981 9.34433 23.075 5.23621 26.46C-1.69379 32.52 -0.643785 43.73 2.11621 51.61C6.28621 63.48 18.9362 71.73 29.7062 77.1C42.1362 83.31 55.7862 86.95 69.4862 88.95C81.4862 90.78 96.8962 92.1 107.296 84.26C116.856 77.06 119.476 60.62 117.136 49.52C116.568 46.2387 114.818 43.2792 112.216 41.2C105.506 36.29 95.4962 39.57 87.9562 39.73C85.1562 39.83 82.3162 39.95 79.4562 39.95Z",
    fill: "#3B0069",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9663 108.45C79.2407 108.45 95.6763 107.425 95.6763 106.16C95.6763 104.895 79.2407 103.87 58.9663 103.87C38.692 103.87 22.2563 104.895 22.2563 106.16C22.2563 107.425 38.692 108.45 58.9663 108.45Z",
    fill: "#3B0069",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.436 25.79C111.978 25.79 112.416 25.3512 112.416 24.81C112.416 24.2687 111.978 23.83 111.436 23.83C110.895 23.83 110.456 24.2687 110.456 24.81C110.456 25.3512 110.895 25.79 111.436 25.79Z",
    fill: "#3B0069"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1763 18.81C69.7175 18.81 70.1563 18.3712 70.1563 17.83C70.1563 17.2887 69.7175 16.85 69.1763 16.85C68.635 16.85 68.1963 17.2887 68.1963 17.83C68.1963 18.3712 68.635 18.81 69.1763 18.81Z",
    fill: "#3B0069"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0364 82.35V86.65",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8862 84.5H32.1862",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2664 0.5V4.8",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1062 2.6499H16.4162",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2163 22.6499V26.9599",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0662 24.8099H94.3662",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2963 80.23C57.9161 86.6887 64.908 91.0523 72.7397 92.3645C80.5713 93.6766 88.6037 91.8302 95.0763 87.23C95.8763 86.6623 96.6472 86.0549 97.3863 85.41L109.316 89.02L104.746 75.67C107.028 70.8947 108.005 65.6009 107.579 60.3258C107.154 55.0508 105.34 49.9822 102.323 45.6343C99.3058 41.2865 95.192 37.8142 90.3993 35.5698C85.6066 33.3255 80.3054 32.3888 75.0338 32.855C69.7621 33.3212 64.7076 35.1737 60.3832 38.2243C56.0587 41.275 52.6182 45.4153 50.4108 50.2252C48.2034 55.0351 47.3076 60.3433 47.8144 65.6112C48.3212 70.8791 50.2125 75.9192 53.2963 80.22V80.23Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0662 64.81C89.1597 64.81 90.0462 63.9235 90.0462 62.83C90.0462 61.7364 89.1597 60.85 88.0662 60.85C86.9727 60.85 86.0862 61.7364 86.0862 62.83C86.0862 63.9235 86.9727 64.81 88.0662 64.81Z",
    fill: "#3B0069"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5164 64.81C79.6099 64.81 80.4964 63.9235 80.4964 62.83C80.4964 61.7364 79.6099 60.85 78.5164 60.85C77.4229 60.85 76.5364 61.7364 76.5364 62.83C76.5364 63.9235 77.4229 64.81 78.5164 64.81Z",
    fill: "#3B0069"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9763 64.81C70.0699 64.81 70.9563 63.9235 70.9563 62.83C70.9563 61.7364 70.0699 60.85 68.9763 60.85C67.8828 60.85 66.9963 61.7364 66.9963 62.83C66.9963 63.9235 67.8828 64.81 68.9763 64.81Z",
    fill: "#3B0069"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0764 59.82C58.4567 66.2787 51.4647 70.6423 43.6331 71.9544C35.8014 73.2666 27.769 71.4202 21.2964 66.82C20.4941 66.2554 19.723 65.6479 18.9864 65L7.0564 68.63L11.6264 55.27C9.34517 50.4947 8.36777 45.2009 8.79337 39.9258C9.21896 34.6507 11.0324 29.5821 14.0497 25.2343C17.067 20.8865 21.1807 17.4142 25.9734 15.1698C30.7662 12.9254 36.0673 11.9888 41.3389 12.455C46.6106 12.9212 51.6651 14.7736 55.9895 17.8243C60.314 20.875 63.7545 25.0153 65.9619 29.8252C68.1693 34.6351 69.0651 39.9433 68.5583 45.2112C68.0516 50.479 66.1603 55.5191 63.0764 59.82Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1562 48.2299C31.0436 46.731 32.3028 45.4866 33.812 44.6169C35.3212 43.7473 37.0294 43.2819 38.7711 43.2658C40.5129 43.2497 42.2293 43.6835 43.7544 44.5251C45.2794 45.3667 46.5614 46.5877 47.4762 48.0699",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0262 39.44C50.8049 39.44 51.4362 38.8087 51.4362 38.03C51.4362 37.2513 50.8049 36.62 50.0262 36.62C49.2475 36.62 48.6162 37.2513 48.6162 38.03C48.6162 38.8087 49.2475 39.44 50.0262 39.44Z",
    fill: "#3B0069"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6864 39.44C28.4651 39.44 29.0964 38.8087 29.0964 38.03C29.0964 37.2513 28.4651 36.62 27.6864 36.62C26.9076 36.62 26.2764 37.2513 26.2764 38.03C26.2764 38.8087 26.9076 39.44 27.6864 39.44Z",
    fill: "#3B0069"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySnag);
export default __webpack_public_path__ + "static/media/EmptySnag.6117665cda345f651b72e7d5d385873c.svg";
export { ForwardRef as ReactComponent };